import { useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Avatar from '../Avatar';
import { MemberStatus } from '../common';

const MembersListModal = ({ members, btnSize }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [searchParam, setSearchParam] = useState('');
  const projectMembers = [...members];
  return (
    <>
      <button
        className={
          btnSize === 'lg'
            ? 'btn btn-lg btn-rounded-circle btn-white lift'
            : 'btn btn-sm btn-rounded-circle btn-white lift'
        }
        onClick={handleShow}
        title="view all"
        type="button"
      >
        <i className="mdi mdi-dots-horizontal" />
      </button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title className="m-0">Members</Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleClose}
          />
        </Modal.Header>
        <div className="card-header">
          <Form>
            <div className="input-group input-group-flush input-group-merge">
              <input
                type="text"
                value={searchParam}
                className="form-control list-search"
                onChange={(e) => setSearchParam(e.target.value)}
                placeholder="Search"
                autoComplete="off"
              />
            </div>
          </Form>
        </div>
        <Modal.Body>
          <section className="modal-scroll-content">
            <ul className="list-group list-group-flush list my-n3">
              {projectMembers
                .filter((item) => {
                  if (!searchParam) return true;
                  if (
                    item.firstName.includes(searchParam) ||
                    item.lastName.includes(searchParam)
                  ) {
                    return true;
                  }
                  return false;
                })
                .map((member, index) => (
                  <li className="list-group-item" key={`${index}${member._id}`}>
                    <div className="row align-items-center">
                      <div className="col-auto">
                        <div className="avatar">
                          <Avatar
                            firstName={member.firstName}
                            lastName={member.lastName}
                            imgPath={member.avatar ? member.avatar : ''}
                          />
                        </div>
                      </div>
                      <div className="col ml-n2">
                        <h4 className="mb-1 names">{`${member.firstName} ${member.lastName}`}</h4>
                        <MemberStatus memberId={member._id || member.userId} />
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
          </section>
        </Modal.Body>
      </Modal>
    </>
  );
};

MembersListModal.propTypes = {
  members: PropTypes.array,
  btnSize: PropTypes.string,
};

export default MembersListModal;
